export const optionsLitigationSubStatus: string[] = [
    "",
    "Attorney Lien",
    "Bankruptcy",
    "Child Support",
    "Workers Comp",
];

export const optionsLitigationSubStatusWithNone = [
    "None",
    ...optionsLitigationSubStatus.filter((option) => option !== ""),
];
